import { ChevronUp, ChevronDown, Edit } from "react-feather";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Col,
  Container,
  Row,
  Table,
} from "reactstrap";
import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { P } from "../../../AbstractElements";
import { taxData } from "../../../data/tax-type/TaxType";

const addSpaces = (str: string) => {
  if (/^[A-Z]{2,}$/.test(str)) {
    return str;
  }
  return str.replace(/([A-Z])/g, " $1").trim();
};

function TaxInfoCountry() {
  const { countryName } = useParams();
  const navigate = useNavigate();
  const [open, setOpen] = useState<string>("1");

  const toggle = (id: string) => {
    setOpen(open === id ? "" : id);
  };

  const handleEditClick = (taxType: string) => {
    const normalizedCountry = countryName?.replace(/%20/g, " ") || "India";
    navigate(`/masterdata/add-tax-type?country=${normalizedCountry}&taxType=${taxType}`);
  };

  const normalizedCountryName = countryName?.replace(/%20/g, " ") || "India";
  const countryTaxes =
    taxData[normalizedCountryName as keyof typeof taxData] || taxData.India;

  return (
    <Container fluid>
      <Row>
        <Col xl="12" sm="12">
          <Accordion open={open} toggle={toggle}>
            {Object.keys(countryTaxes).map((taxType, index) => (
              <AccordionItem key={index + 1}>
                <AccordionHeader
                  targetId={String(index + 1)}
                  className="d-flex justify-content-between align-items-center w-100 bg-light"
                >
                  <div className="d-flex align-items-center text-dark">
                    <h5
                      className="mb-0 text-capitalize"
                      style={{ minWidth: "160px" }}
                    >
                      {addSpaces(taxType)}
                    </h5>
                  </div>
                  <div className="d-flex align-items-center ml-auto">
                    <em className="text-muted">
                      Effective From:{" "}
                      {countryTaxes[taxType][0].applicableDate.effectiveFrom}
                    </em>
                  </div>
                  <div className="d-flex align-items-center">
                    <Edit
                      className="svg-color"
                      size={16}
                      style={{ marginRight: "28px", color: "var(--theme-default, #6c757d)" }}
                      onClick={() => handleEditClick(taxType)}
                    />
                    {!countryTaxes[taxType][0].static && (
                      open === String(index + 1) ? (
                        <ChevronUp
                          className="svg-color"
                          size={20}
                          style={{ color: "var(--theme-default, #6c757d)" }}
                        />
                      ) : (
                        <ChevronDown
                          className="svg-color"
                          size={20}
                          style={{ color: "var(--theme-default, #6c757d)" }}
                        />
                      )
                    )}
                  </div>
                </AccordionHeader>
                <AccordionBody accordionId={String(index + 1)}>
                  {countryTaxes[taxType][0].data && (
                    <Table responsive className="mb-0">
                      <thead>
                        <tr>
                          {countryTaxes[taxType][0].headers!.map(
                            (header: string, idx: number) => (
                              <th scope="col" key={idx}>
                                {header}
                              </th>
                            )
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {countryTaxes[taxType][0].data!.map(
                          (row: { [key: string]: string }, idx: number) => (
                            <tr key={idx}>
                              {Object.values(row).map(
                                (value: string, i: number) => (
                                  <td key={i}>{value}</td>
                                )
                              )}
                            </tr>
                          )
                        )}
                      </tbody>
                    </Table>
                  )}
                  {countryTaxes[taxType][0].static && (
                    <P>
                      {taxType} is a static tax type with no slabs. Details vary
                      by state or regulation.
                    </P>
                  )}
                </AccordionBody>
              </AccordionItem>
            ))}
          </Accordion>
        </Col>
      </Row>
    </Container>
  );
}

export default TaxInfoCountry;